import {
  PackageId,
  type PackageServiceDomainSelectModel,
  PackageServiceId,
  ServiceTypes,
} from '@mntn-dev/domain-types'
import { getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'
import { MockService } from './mock-service.ts'

export const MockPackageService = MockModel<PackageServiceDomainSelectModel>(
  ({
    packageServiceId = PackageServiceId(),
    packageId = PackageId(),
    serviceType = getRandomItem(ServiceTypes),
    count = 1,
    cost,
  }) => {
    const { status, ...service } = MockService({ status: 'published' })

    return {
      packageServiceId,
      packageId,
      serviceType,
      count,
      cost,
      ...service,
    } satisfies PackageServiceDomainSelectModel
  }
)
